import type { FreeLayoutPluginContext } from '@flowgram.ai/free-layout-editor';
import { getRegisteredTeamFlowContext, subscribeTeamFlowContextChange } from './teamFlowContextRegistry';

export interface TeamFlowLoadedIdentity {
  projectId: string;
  roomId: string;
  canvasId: string;
  scopeKey: string;
}

const identities = new WeakMap<FreeLayoutPluginContext, TeamFlowLoadedIdentity>();
const listeners = new Set<() => void>();

/** 文档载入和编辑器注册都可能迟到，统一通知等待真实画布的创建入口。 */
function notifyLoadedIdentity(): void {
  listeners.forEach((listener) => listener());
}

subscribeTeamFlowContextChange(notifyLoadedIdentity);

/** 只登记后端数据已经载入的目标；清理旧实例时不能删除随后登记的新身份。 */
export function registerLoadedTeamFlowIdentity(ctx: FreeLayoutPluginContext, identity: TeamFlowLoadedIdentity): () => void {
  identities.set(ctx, identity);
  notifyLoadedIdentity();
  return () => {
    if (identities.get(ctx) !== identity) return;
    identities.delete(ctx);
    notifyLoadedIdentity();
  };
}

/** 当前注册的编辑器必须已经完成目标文档载入，才能提供创建来源身份。 */
export function getLoadedTeamFlowIdentity(ctx = getRegisteredTeamFlowContext()): TeamFlowLoadedIdentity | undefined {
  if (!ctx || ctx !== getRegisteredTeamFlowContext()) return undefined;
  return identities.get(ctx);
}

/** 返回稳定的文档身份快照，支持 useSyncExternalStore 等待挂载和重新载入。 */
export function subscribeLoadedTeamFlowIdentity(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
